<template>
  <div class="v-icon mr-2 ">
    <v-dialog
      :value="editTeamDialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <DialogTitle
          :close="closeEditItem"
          :dialog-name="dialogName"
        />
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  counter
                  label="Name"

                  maxlength="90"
                  v-model="editName"
                />
              </v-flex>
              <v-flex
                  md12
                  sm12
                  xs12
              >
                  <v-select
                      :items="[{Id: true, name: 'Live'}, {Id: false, name: 'Not Live'}]"
                      item-text="name"
                      item-value="Id"
                      label="Is Live"
                      v-model="editIsActive"
                  />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <DialogActions
          :close="closeEditItem"
          :save="saveEditItemAndCloseDialog"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import EditTableFunctions from '@/components/editTableFunctions';

    import {LOAD_TEAM_TO_EDIT, RESET_DEFAULT_TEAM_TO_EDIT, TOGGLE_EDIT_TEAM_DIALOG, UPDATE_TEAM_FIELD} from "@/store/team/mutations";
    import {FETCH_TEAM_LIST, SAVE_EDITED_TEAM} from "@/store/team/actions.js";
    import DialogTitle from "../../../components/DialogTitle";
    import DialogActions from "../../../components/DialogActions";

    export default {
        name: "EditTeamDialog",

        validations: {
            // editAddressLineOne: { required },
            // editPostCode: { required },
            // editEmailAddressPersonal: { email },
        },

        components: {
            DialogActions,
            DialogTitle
        },

        mixins: [
            EditTableFunctions,
        ],


        props: {
            // item: {
            //     type: Object,
            //     required: true,
            // },
        },
        data() {
            return {
                // Required for editTableFunctions
                dialogName: 'Edit Team',
                startDateMenu: false,
                endDateMenu: false,
            }
        },
        computed: {
            editTeamDialog: {
                get() {
                    return this.$store.state.team.editTeamDialog;
                },
            },
            editName: {
                get() {
                    return this.$store.state.team.editTeam.name;
                },
                set(value) {
                    this.updateEditedValue('name', value);
                },
            },
            editIsActive: {
                get() {
                    return this.$store.state.team.editTeam.isActive;
                },
                set(value) {
                    this.updateEditedValue('isActive', value);
                },
            },
            ...mapGetters(
            []
            ),
            ...mapGetters({
                id: "editTeamId"
            })
        },

        methods: {
            // fetchEcsCompanyList() {
            //     this.$store.dispatch(FETCH_ECS_COMPANY_LIST);
            // },
            async validateAll() {

                this.$v.$touch();

                let formState = false;

                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }

                let areValid = false;

                if (formState == 'complete') {
                    areValid = true;
                }

                return areValid;
            },

            ...mapActions({
                fetchItem: FETCH_TEAM_LIST,
                updateTableItemRecord: SAVE_EDITED_TEAM,
                // saveNewTableItemRecord: '',
                // deleteTableItem: '',
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_TEAM_DIALOG,
                loadTableItemToEdit: LOAD_TEAM_TO_EDIT,
                updateTableItemToEdit: UPDATE_TEAM_FIELD,
                resetEditItemToDefault: RESET_DEFAULT_TEAM_TO_EDIT,
            }),

        },

    }
</script>

<style scoped>
</style>
